import { render, staticRenderFns } from "./exam-paper.vue?vue&type=template&id=58004d2e&scoped=true&"
import script from "./exam-paper.vue?vue&type=script&lang=js&"
export * from "./exam-paper.vue?vue&type=script&lang=js&"
import style0 from "./exam-paper.vue?vue&type=style&index=0&id=58004d2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58004d2e",
  null
  
)

export default component.exports